<template>
    <v-container fill-height fluid grid-list-xl class="pt-0">
        <v-flex md12>
            <material-card color="green" title="Menu Summary" class="grid-card">
                <vue-good-table
                    class="pt-0"
                    style="cursor: pointer;"
                    ref="table"
                    :columns="columns"
                    :rows="menuSummary"
                    :search-options="{
                        enabled: false,
                    }"
                >
                    <div
                        slot="table-actions"
                        style="display: flex; flex-flow: row;"
                        class="action_buttons"
                    >
                        <v-switch
                            color="success"
                            class="mr-3"
                            v-model="groupBySite"
                            label="Group By Site"
                            @change="loadData"
                        ></v-switch>
                        <v-select
                            style="width: 300px;"
                            class="mr-2 pb-2"
                            label="Sites"
                            multiple
                            @change="loadData"
                            :items="sites"
                            v-model="sitesFilter"
                            hide-details
                        >
                            <template v-slot:selection="{ item, index }">
                                <v-chip v-if="index === 0">
                                    <span>{{ item }}</span>
                                </v-chip>
                                <span
                                    v-if="index === 1"
                                    class="grey--text caption"
                                    >(+{{
                                        sitesFilter.length - 1
                                    }}
                                    others)</span
                                >
                            </template>
                        </v-select>
                        <v-select
                            style="width: 200px; padding-top: 20px !important;"
                            class="mr-2 pb-2"
                            label="Distribution"
                            @change="distributionChanged"
                            :items="distributions.map((d) => d.week)"
                            v-model="distributionName"
                            hide-details
                        ></v-select>
                        <v-spacer></v-spacer>
                        <download-excel
                            :fields="exportFields()"
                            :name="getExportFileName()"
                            :before-generate="() => (isExporting = true)"
                            :before-finish="() => (isExporting = false)"
                            :fetch="exportToExcel"
                            type="xls"
                        >
                            <v-btn
                                small
                                icon
                                :loading="isExporting"
                                class="mt-3"
                                ><v-icon color="success"
                                    >mdi-file-export</v-icon
                                ></v-btn
                            >
                        </download-excel>
                    </div>
                    <template slot="table-header-row" slot-scope="props">
                        <div>
                            <span>
                                {{ props.formattedRow[props.column.field] }}
                            </span>
                        </div>
                    </template>
                    <template slot="table-row" slot-scope="props">
                        <div class="font-weight-regular">
                            <span>
                                {{ props.formattedRow[props.column.field] }}
                            </span>
                        </div>
                    </template>
                </vue-good-table>
            </material-card>
        </v-flex>
    </v-container>
</template>

<script>
import { pluralize, sum, formatCurrency } from "../../utils/helpers.js";
import moment from "moment";

export default {
    data: () => ({
        menuSummary: [],
        regID: "",
        isExporting: false,
        distributions: [],
        distributionID: "",
        distributionName: "",
        campInfo: [],
        sites: [],
        sitesFilter: [],
        groupBySite: false,

        columns: [
            {
                sortable: false,
                label: "Site",
                field: "site",
                hidden: false,
            },
            {
                sortable: false,
                label: "Menu Item",
                field: "menuItem",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Quantity",
                field: "quantity",
                type: "Number",
                hidden: false,
            },
            {
                sortable: false,
                label: "Families",
                field: "families",
                type: "Number",
                hidden: false,
            },
        ],
    }),
    watch: {},
    async created() {
        await this.loadDistributions();

        await this.loadCampInfo();

        this.loadData();
    },
    methods: {
        async loadData() {
            const response = await this.$http.get(
                "api/CampDistribution/GetMenuSummary?distributionID=" +
                    this.distributionID +
                    "&groupBySite=" +
                    this.groupBySite +
                    "&sitesFilter=" +
                    this.getSitesFilter()
            );

            this.menuSummary = response;

            // this.menuSummary = this.getBranch()
            //     ? response.filter((r) =>
            //           this.getBranch()
            //               .split(",")
            //               .includes(r.branch)
            //       )
            //     : response;
        },
        async loadCampInfo() {
            this.campInfo = await this.$http.get(
                "api/campDistribution/getCampInfo"
            );

            const branchList = this.getBranch().split(",");

            this.sites = this.getBranch()
                ? this.campInfo
                      .filter((c) => branchList.includes(c.branch))
                      .map((c) => c.campNameEng)
                : this.campInfo.map((c) => c.campNameEng);
            this.sitesFilter = this.getBranch()
                ? this.campInfo
                      .filter((c) => branchList.includes(c.branch))
                      .map((c) => c.campNameEng)
                : [];
        },
        getSitesFilter() {
            const branchList = this.getBranch().split(",");

            if (this.getBranch()) {
                return this.sitesFilter.length
                    ? this.sitesFilter.map((s) => this.getCampID(s)).join(",")
                    : this.campInfo
                          .filter((c) => branchList.includes(c.branch))
                          .map((c) => c.id)
                          .join(",");
            }

            return this.sitesFilter.map((s) => this.getCampID(s)).join(",");
        },
        getCampID(campName) {
            return this.campInfo.find((c) => c.campNameEng == campName).id;
        },
        getBranch() {
            return this.$store.state.authentication.branch &&
                !this.$store.state.authentication.branch.includes("null")
                ? this.$store.state.authentication.branch
                : "";
        },
        async loadDistributions() {
            this.distributions = await this.$http.get(
                "api/campDistribution/getDistributions"
            );

            const last = this.distributions[this.distributions.length - 1];
            this.distributionName = last.week;
            this.distributionID = last.id;
        },
        distributionChanged(value) {
            this.distributionID = this.distributions.find(
                (d) => d.week == value
            ).id;

            this.loadData();
        },
        getExportFileName() {
            return "Menu Summary - " + moment().format("L");
        },

        exportFields() {
            let fields = {};

            this.columns.forEach((column) => {
                if (column.hidden) return;

                fields[column.label] = column.field;
            });

            return fields;
        },

        async exportToExcel() {
            return this.menuSummary;
        },
    },
};
</script>
<style>
.toggle-button {
    font-size: 15px;
    padding: 5px !important;
}
.toggle-button-group.v-btn-toggle .v-btn.v-btn--active {
    background-color: #dcdfe6;
}
.v-btn__content {
    color: unset;
}
</style>
